import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSearch,
    faGlobe,
    faAngleLeft,
    faArrowLeft,
    faClock,
    faBars,
    faUtensils, faMap, faInfoCircle, faAngleDown
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSearch);
library.add(faGlobe);
library.add(faAngleLeft);
library.add(faArrowLeft);
library.add(faClock);
library.add(faBars);
library.add(faUtensils);
library.add(faMap);
library.add(faInfoCircle);
library.add(faAngleDown);
export default FontAwesomeIcon
